
export default {
  props: {
    show: {type: Boolean, default: false},
    arrowDown: {type: Boolean, default: false}
  },
}
